module.exports = __webpack_public_path__ + "static/media/material-arrow-downward.38318922.svg";